exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apportionment-details-content .layout[data-v-29544a9c] {\n  padding: 26px 16px;\n  display: flex;\n  flex-direction: column;\n}\n.apportionment-details-content .functions[data-v-29544a9c] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.apportionment-details-content .functions .item[data-v-29544a9c] {\n  display: flex;\n  align-items: center;\n}\n.apportionment-details-content .functions .item p[data-v-29544a9c] {\n  margin-bottom: -3px;\n}\n", ""]);

// exports
